<script setup lang="ts">
defineProps<{
    title: string;
}>();
const emit = defineEmits<{
    close: [];
}>();
const { isMobile } = useSize(true);
</script>

<template>
    <mr-modal width="400px" :title @close="emit('close')">
        <div class="support-menu">
            <slot :close="() => emit('close')" />
        </div>
        <template v-if="isMobile" #footer>
            <mr-button
                class="back-action"
                variant="bordered"
                full-width
                @click="emit('close')"
            >
                بازگشت
            </mr-button>
        </template>
    </mr-modal>
</template>

<style scoped lang="scss">
.support-menu {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 5px;
}
</style>
